/* eslint no-unused-vars: ["error", { "args": "none" }] */
import api from '@/api';
import utilities from '@/helpers/utilities';
import i18n from '@/i18n';

const state = {
    demandOwnerSubstitutions: [],
    demandOwnerSubstitution: {},
};

const mutations = {
    setDemandOwnerSubstitutions(state, demandOwnerSubstitutions) {
        state.demandOwnerSubstitutions = demandOwnerSubstitutions;
    },
    setDemandOwnerSubstitution(state, demandOwnerSubstitution) {
        state.demandOwnerSubstitution = demandOwnerSubstitution;
    },
};

const actions = {

    // CRUD
    async fetchDemandOwnerSubstitution({ commit, dispatch }, id) {
        const response = await api.demandOwnerSubstitutions.fetch(id);
        commit('setDemandOwnerSubstitution', response.data);
    },
    async loadDemandOwnerSubstitutions({ commit }) {
        const response = await api.demandOwnerSubstitutions.list();
        commit('setDemandOwnerSubstitutions', response.data);
    },
    async removeDemandOwnerSubstitution({ dispatch }, form) {
        await api.demandOwnerSubstitutions.remove(form.id);
        await dispatch('loadDemandOwnerSubstitutions');
        await dispatch('loadDemands');

        dispatch('showSuccess', i18n.t('message.success.demandOwnerSubstitutionRemoved'));
    },
    async saveDemandOwnerSubstitution({ commit, dispatch }, form) {
        await api.demandOwnerSubstitutions.save(form);
    },
    async saveOrUpdateDemandOwnerSubstitution({ dispatch }, form) {
        if (utilities.isEmptyOrZero(form.id)) {
            await dispatch('saveDemandOwnerSubstitution', form);
        } else {
            await dispatch('updateDemandOwnerSubstitution', form);
        }

        await dispatch('loadDemandOwnerSubstitutions');
        await dispatch('loadDemands');
        dispatch('showSuccess', i18n.t('message.success.saved'));
    },
    async updateDemandOwnerSubstitution({ dispatch }, form) {
        await api.demandOwnerSubstitutions.update(form.id, form);
    },
};

const getters = {
    demandOwnerSubstitution(state) {
        return state.demandOwnerSubstitution || {};
    },
    demandOwnerSubstitutions(state) {
        const demandOwnerSubstitutions = state.demandOwnerSubstitutions || [];
        return demandOwnerSubstitutions;
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/demandOwnerSubstitutions.js